import { loginTg } from "../Api/telegram.js";

export default {
    state: {
        telegramInitData: null,
        telegramLoginPending: false,
        isTelegram: false,
        isFullScreenOpen: false,
    },
    mutations: {
        SET_TELEGRAM_INIT_DATA(state, payload) {
            state.telegramInitData = payload;
        },
        SET_TELEGRAM_LOGIN_PENDING(state, payload) {
            state.telegramLoginPending = payload;
        },
        SET_IS_TELEGRAM(state, payload) {
            state.isTelegram = payload;
        },
        SET_IS_FULL_SCREEN_OPEN(state, payload) {
            state.isFullScreenOpen = payload;
        },
    },

    actions: {
        async loginTg({ commit }) {
            if (!this.state.telegram.telegramInitData) return;
            console.log("loading telegram login...");

            commit("SET_TELEGRAM_LOGIN_PENDING", true);
            const response = await loginTg(
                this.state.telegram.telegramInitData
            );
            if (response.status === 200) {
                const data = response.data;
                const token = data.token;
                const abonement = data.abonement;
                localStorage.setItem("token", token);
                localStorage.setItem("abonement", abonement);
                localStorage.setItem("access", true);
                console.log("loading telegram login... ended");
                window.history.go(-1);
                window.location.reload();
                return response.data;
            } else {
                commit("SET_TELEGRAM_LOGIN_PENDING", false);
                return response;
            }
        },
    },

    getters: {
        getTelegramInitData(state) {
            return state.telegramInitData;
        },
        getTelegramLoginPending(state) {
            return state.telegramLoginPending;
        },
        getIsTelegram(state) {
            return state.isTelegram;
        },
        getIsFullScreenOpen(state) {
            return state.isFullScreenOpen;
        },
    },
};
